// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* index.css */

.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f9f9f9;
  margin-bottom: 20px;
}

.headerContainer {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Vertically center align items */
  margin-bottom: 20px;
}

h2 {
  margin: 0; /* Reset margin */
  font-size: 24px; /* Increase font size for header */
}

.buttons {
  display: flex;
  gap: 10px;
}

.buttons button {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease; /* Smooth transition */
}

.buttonsc {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease; /* Smooth transition */
}

.buttons button:hover {
  background-color: #0056b3;
}

.facility {
  margin: 0 auto 20px; /* Center the facility boxes horizontally */
  padding: 20px; /* Add padding for better spacing */
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #fff;
}

.room {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(50% - 10px); /* Flex basis */
  margin-right: 20px;
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #fff;
}

.details {
  margin-top: 10px;
}

.room p {
  margin: 5px 0;
}

@media (max-width: 600px) {
  .rooms {
    display: flex;
    flex-direction: column;
  }
  .headerContainer {
    display: flex;
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Settings/Layout/index.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB,EAAE,kCAAkC;EACvD,mBAAmB;AACrB;;AAEA;EACE,SAAS,EAAE,iBAAiB;EAC5B,eAAe,EAAE,kCAAkC;AACrD;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,sCAAsC,EAAE,sBAAsB;AAChE;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,sCAAsC,EAAE,sBAAsB;AAChE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB,EAAE,2CAA2C;EAChE,aAAa,EAAE,mCAAmC;EAClD,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B,EAAE,eAAe;EAC3C,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,eAAe;EACjB;AACF","sourcesContent":["/* index.css */\n\n.container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background-color: #f9f9f9;\n  margin-bottom: 20px;\n}\n\n.headerContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center; /* Vertically center align items */\n  margin-bottom: 20px;\n}\n\nh2 {\n  margin: 0; /* Reset margin */\n  font-size: 24px; /* Increase font size for header */\n}\n\n.buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.buttons button {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  background-color: #007bff;\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 0.3s ease; /* Smooth transition */\n}\n\n.buttonsc {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  background-color: #007bff;\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 0.3s ease; /* Smooth transition */\n}\n\n.buttons button:hover {\n  background-color: #0056b3;\n}\n\n.facility {\n  margin: 0 auto 20px; /* Center the facility boxes horizontally */\n  padding: 20px; /* Add padding for better spacing */\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background-color: #fff;\n}\n\n.room {\n  flex: 0 0 calc(50% - 10px); /* Flex basis */\n  margin-right: 20px;\n  margin-bottom: 20px;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background-color: #fff;\n}\n\n.details {\n  margin-top: 10px;\n}\n\n.room p {\n  margin: 5px 0;\n}\n\n@media (max-width: 600px) {\n  .rooms {\n    display: flex;\n    flex-direction: column;\n  }\n  .headerContainer {\n    display: flex;\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
